import React, { useEffect } from "react";

import List from "@mui/material/List";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import Paper from "@mui/material/Paper";

import { hasError, getError } from "../../services/ServiceHelper";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import { getDayForStudent } from "../../services/ActivityService";
import {
  getEmptyTodayActivity,
  getActivityModel,
} from "../../services/ModelFactory";

import { isSameDate } from "../../services/DateService";
import PeriodListItem from "../PeriodListItem";
import SkeletonProgress from "../SkeletonProgress";
/**
 * signupDate - string yyyy-mm-dd
 */
const StudentSelectPeriods = ({ signupDate, sourceUrl }) => {
  const [mySchool] = useLocalStorage("Auth", "school", null);
  const [jwt] = useJwtStorage();

  const navigate = useNavigate();

  let dCurrentDate = dayjs();
  const [dateInterval, setDateInterval] = React.useState(null);

  // number of periods for the day
  const [dayPeriodCount, setDayPeriodCount] = React.useState(0);

  const [_activitiesLoaded, setActivitiesLoaded] = React.useState(false);
  const [currentStudentPeriods, setCurrentStudentPeriods] = useLocalStorage(
    "StudentSelectPeriods",
    "currentStudentPeriods",
    [],
  );
  const [dayPeriods, setDayPeriods] = useLocalStorage(
    "StudentSelectPeriods",
    "dayPeriods",
    [],
  );

  // allocated for 10 periods
  const [selectedActivities, setSelectedActivities] = React.useState([
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
  ]);

  const initActivities = () => {
    setActivitiesLoaded(false);
    getDayForStudent(mySchool, jwt, signupDate)
      .then((result) => {
        if (hasError(result.data) === true) {
          window.showSnack("Unable to get Day: " + getError(result.data));
        } else {
          const studentDayData = result.data;
          loadStudentDay(studentDayData.activities);
        }
      })
      .catch((error) => {
        console.log(error);
        window.showSnack("Unable to get Day.");
      })
      .finally(() => {
        setActivitiesLoaded(true);
      });
  };

  useEffect(() => {
    evalReload();
    initActivities();
    // initCategories();
  }, []);

  const calcTotalPeriodCount = (periods) => {
    let totalSlots = 0;
    for (let i = 0; i < 10; i++) {
      if (periods[`period${i}`] != null) {
        totalSlots++;
      }
    }

    return totalSlots;
  };

  const evalReload = () => {
    if (dateInterval != null) {
      return;
    }

    // every 2 minutes, see if date has changed, and refresh the page
    let interval = setInterval(() => {
      const dDate = dayjs();

      // if changed then set to current date, then init content again
      if (!isSameDate(dDate, dCurrentDate)) {
        dCurrentDate = dDate;
      }
    }, 120000);
    setDateInterval(interval);
  };

  const loadStudentDay = (periods) => {
    const count = calcTotalPeriodCount(periods);
    setDayPeriodCount(count);
    setCurrentStudentPeriods(periods);

    const activities = selectedActivities;

    const dayPeriods = [];
    for (let p = 1; p <= count; p++) {
      const activityDatesInPeriod = periods[`period${p}`];

      if (activityDatesInPeriod == null || activityDatesInPeriod.length === 0) {
        dayPeriods.push(getEmptyTodayActivity(p));
        activities[p - 1].value = "";
      } else {
        // find activity you are registered for
        let foundActivityDate = activityDatesInPeriod[0];

        if (foundActivityDate == null) {
          // NOT found
          dayPeriods.push(getEmptyTodayActivity(p));
          activities[p - 1].value = "";
        } else {
          const activityDate = getActivityModel(p, foundActivityDate);
          dayPeriods.push(activityDate);
          activities[p - 1].value = activityDate.activityDateEid;
        }
      }
    }

    // store the activities that the user has selected
    let key = `selectedActivities.${signupDate}`;
    window.sessionStorage[key] = activities;

    // store the number of periods for the specified day
    key = `dayPeriodCount.${signupDate}`;
    window.sessionStorage[key] = dayPeriodCount;

    setDayPeriods(dayPeriods);
    setSelectedActivities(activities);
  };

  const getTodaysSelectedActivity = (periodNum) => {
    const periodArry = currentStudentPeriods[`period${periodNum}`];

    if (periodArry != null && periodArry.length > 0) {
      // select first (should be just one)
      return periodArry[0];
    }
    return null;
  };

  const handlePeriodClick = (period) => {
    const periodNum = period.period;

    const selectedActivity = getTodaysSelectedActivity(periodNum);

    // look at selected activity, if one exists
    if (selectedActivity != null) {
      if (selectedActivity.modify !== 1) {
        window.showAlert(
          "Unable to Change Activity",
          "You cannot change this activity.  It has been set by your teacher.",
        );
        return;
      }
      if (selectedActivity.lockTeacherId != null) {
        window.showAlert(
          "Unable to Change Activity",
          "You cannot change this activity.  It has been set by your teacher (LT).",
        );
        return;
      }
    }

    const url = `/student/signup`;
    navigate(url);
  };

  return (
    <>
      {_activitiesLoaded === true && (
        <Paper elevation={3} sx={{ mt: 1, mb: 1 }}>
          <List sx={{ width: "100%" }}>
            {dayPeriods.map((period, index) => (
              <PeriodListItem
                key={index + 1}
                school={mySchool}
                periodNumber={index + 1}
                period={period}
                onClick={handlePeriodClick}
              />
            ))}
          </List>
        </Paper>
      )}
      {_activitiesLoaded === false && (
        <SkeletonProgress />
      )}
    </>
  );
};

export default StudentSelectPeriods;
